export enum SessionStorageItemEnum {
  FLIGHT_SEARCH_RESULT = "FLIGHT_SEARCH_RESULT",
  FLIGHT_SELECTED_KEEP = "FLIGHT_SELECTED_KEEP",
  FLIGHT_GFS = "FLIGHT_GFS",
  hotelDetailPriceChangeFlag = "hotelDetailPriceChangeFlag",

  BOOKING_INTERNAL_NO = "bookingInternalNo",
  FLIGHT_AUTO_FILL = "flightAutoFillSearchInput",
  STORAGE_KEY = "refresh_timestamp",
  hasRefreshedPromotion = "hasRefreshedPromotion",
  hasRefreshed403Page = "hasRefreshed403Page",
  PAGE_VIEW_10_SEC = "PAGE_VIEW_10_SEC",

  HOTEL_BOOKING_CACHE_FORM = "HOTEL_BOOKING_CACHE_FORM",
  CAR_RENTAL_BOOKING_CACHE_FORM = "CAR_RENTAL_BOOKING_CACHE_FORM",
  EXP_BOOKING_CACHE_FORM = "EXP_BOOKING_CACHE_FORM",
  HOTEL_SLUG = "HOTEL_SLUG",

  RE_TAB = "RE_TAB",
  SAVE_URL_BACK = "SAVE_URL_BACK",
  ADD_BOOKING_RESPONSE = "addBookingResponse",
}
